import React from 'react';
import get from 'lodash/get';
import merge from 'lodash/merge';
import styled, { ThemeProvider } from 'styled-components';
import * as THEMES from '../../theme';
export var supportedThemes = {
  light: {
    label: 'Light',
    theme: THEMES.LightTheme
  },
  dark: {
    label: 'Dark',
    theme: THEMES.DarkTheme
  }
};
export function determineTheme(key) {
  return get(supportedThemes, [key, 'theme'], THEMES.LightTheme);
}
/**
 * Used to apply base theme properties to entire styled root DOM tree
 */

var StyledBase = styled.div.withConfig({
  displayName: "ThemeProvider__StyledBase",
  componentId: "o4lf7a-0"
})(["color:", ";background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.text;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.background;
});
export default function CustomThemeProvider(props) {
  var children = props.children,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'light' : _props$mode,
      _props$theme = props.theme,
      customTheme = _props$theme === void 0 ? {} : _props$theme;
  var theme = merge({}, determineTheme(mode), customTheme);
  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(StyledBase, null, children));
}